import '../App.css'
export default function Page({ children }) {
  return (
    <div className="App">
      {children}
    </div >
  )
}